import httpClient from '@/shared/http-eserv-client';
import { formatDate } from '@/utils/report-utils';

const getMyOpenInvoices = (userId) => httpClient.get(`/ApplicationRequests/MyInvoices?userId=${userId}&$filter=invoiceStatus ne 'Paid' and invoiceStatus ne 'Paid (Refund)' and invoiceStatus ne 'Cancelled' and invoiceStatus ne 'Refund' and invoiceStatus ne 'Cancelled-WO'`);
const getMyClosedInvoices = (userId) => httpClient.get(`/ApplicationRequests/MyInvoices?userId=${userId}&$filter=invoiceStatus eq 'Paid' or invoiceStatus eq 'Paid (Refund)' or invoiceStatus eq 'Cancelled' or invoiceStatus eq 'Cancelled-WO'`);
const getMyOpenInvoicesByEmail = (email) => httpClient.get(`/ApplicationRequests/MyInvoicesByEmail?email=${email}&$filter=invoiceStatus ne 'Paid' and invoiceStatus ne 'Paid (Refund)' and invoiceStatus ne 'Cancelled'and invoiceStatus ne 'Refund' and invoiceStatus ne 'Cancelled-WO'`);
const getMyClosedInvoicesByEmail = (email) => httpClient.get(`/ApplicationRequests/MyInvoicesByEmail?email=${email}&$filter=invoiceStatus eq 'Paid' or invoiceStatus eq 'Paid (Refund)' or invoiceStatus eq 'Cancelled' or invoiceStatus eq 'Cancelled-WO'`);
const getMyOpenInvoicesByOwner = (ownerId, ownerContactId) => httpClient.get(`/ApplicationRequests/MyInvoicesByOwner?ownerId=${ownerId}&ownerContactId=${ownerContactId}&$filter=invoiceStatus ne 'Paid' and invoiceStatus ne 'Paid (Refund)' and invoiceStatus ne 'Cancelled' and invoiceStatus ne 'Refund' and invoiceStatus ne 'Cancelled-WO'`);
const getMyClosedInvoicesByOwner = (ownerId, ownerContactId) => httpClient.get(`/ApplicationRequests/MyInvoicesByOwner?ownerId=${ownerId}&ownerContactId=${ownerContactId}&$filter=invoiceStatus eq 'Paid' or invoiceStatus eq 'Paid (Refund)' or invoiceStatus eq 'Cancelled' or invoiceStatus eq 'Cancelled-WO'`);
const getMyInvoices = (userId) => httpClient.get(`/ApplicationRequests/MyInvoices?userId=${userId}`);

const getRptSearchRequestApplications = (dateFrom, dateTo) => {
  const startDateParam = `from=${dateFrom ? formatDate(dateFrom) : ''}`;
  const endDateParam = `to=${dateTo ? formatDate(dateTo) : ''}`;
  return httpClient.get(`/Reports/RptSearchRequestApplications?${startDateParam}&${endDateParam}`);
};

const getTransactions = () => new Promise((resolve) => resolve({ data: [] }));
// httpClient.get('/invoices');
const getMyDropdownData = () => new Promise((resolve) => resolve({ data: [] }));
// httpClient.get('/my-dropdown-data');
const getInvoicePDF = (accessToken, userId, invoiceId) => httpClient.get(`/Invoices/pdf?securityToken=${accessToken}&userId=${userId}&invoiceId=${invoiceId}`);
const getInvoiceOwners = () => httpClient.get('/Invoices/InvoiceOwners');

const getAutoEmailReports = (ProductCode, startDate, endDate) => {
  const codeParam = `ProductCode=${ProductCode}`;
  const startDateParam = `startDate=${startDate ? formatDate(startDate) : ''}`;
  const endDateParam = `endDate=${endDate ? formatDate(endDate) : ''}`;
  return httpClient.get(`/Reports/RptAutoEmailV?${codeParam}&${startDateParam}&${endDateParam}`);
};
const getReceiptPDF = (accessToken, userId, orderId, invoiceId) => httpClient.get(`/invoices/receipt?securityToken=${accessToken}&userId=${userId}&orderId=${orderId}&invoiceId=${invoiceId}`);

// eslint-disable-next-line import/prefer-default-export
export {
  getMyOpenInvoices,
  getMyClosedInvoices,
  getMyInvoices,
  getTransactions,
  getMyDropdownData,
  getInvoicePDF,
  getInvoiceOwners,
  getMyOpenInvoicesByEmail,
  getMyClosedInvoicesByEmail,
  getMyOpenInvoicesByOwner,
  getMyClosedInvoicesByOwner,
  getRptSearchRequestApplications,
  getAutoEmailReports,
  getReceiptPDF,
};
